import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthGuard } from './components/auth-guard';
import { GuestGuard } from './components/guest-guard';
import { LoadingScreen } from './components/loading-screen';
import { Layout } from './components/layout';

const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// Auth pages
const Login = Loadable(
  lazy(() => import('./features/auth').then((module) => ({ default: module.Login })))
);
const ForgotPassword = Loadable(
  lazy(() => import('./features/auth').then((module) => ({ default: module.ForgotPassword })))
);
const TwoFactorAuthentication = Loadable(
  lazy(() => import('./features/auth').then((module) => ({ default: module.TwoFactorAuthentication })))
);
const CreatePassword = Loadable(
  lazy(() => import('./features/auth').then((module) => ({ default: module.CreatePassword })))
);
const ResetPassword = Loadable(
  lazy(() => import('./features/auth').then((module) => ({ default: module.ResetPassword })))
);
const LinkValidation = Loadable(
  lazy(() => import('./features/auth').then((module) => ({ default: module.LinkValidation })))
);

// Features pages
const UsersPage = Loadable(
  lazy(() => import('./features/users').then((module) => ({ default: module.Users })))
);

// user details
const UserDetailsPage = Loadable(
  lazy(() => import('./features/userDetails').then((module) => ({ default: module.UserDetails })))
);

// not found
const NotFound = Loadable(
  lazy(() => import('./features/notFound').then((module) => ({ default: module.NotFound })))
);

const routes = [
  {
    path: '/',
    element: <Navigate to="/dashboard/users/list" replace />
  },
  {
    path: 'login',
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    )
  },
  {
    path: 'password-recovery',
    element: (
      <GuestGuard>
        <ForgotPassword />
      </GuestGuard>
    )
  },
  {
    path: 'two-factor-authentication',
    element: (
      <GuestGuard>
        <TwoFactorAuthentication />
      </GuestGuard>
    )
  },
  {
    path: 'initial-password',
    element: <CreatePassword />
  },
  {
    path: 'link-validation',

    children: [
      {
        path: ':token',
        element: <LinkValidation />
      }
    ]
  },
  {
    path: 'password-reset',
    children: [
      {
        path: ':token',
        element: <ResetPassword />
      }
    ]
  },
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        path: '/dashboard',
        element: <Navigate to="/dashboard/users/list" replace />
      },
      {
        path: 'users',
        children: [
          {
            // path: '/',
            element: <Navigate to="/dashboard/users/list" replace />
          },
          {
            path: 'list',
            element: <UsersPage />
          },
          {
            path: 'details',
            children: [
              {
                path: ':uuid',
                element: <UserDetailsPage />
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
